<template>
    <div class="jump-cart">
        <!-- <van-nav-bar title="我的评论" left-arrow fixed class="jump-nav-bar"
         right-text="管理"
         @click-left="back" />-->
        <van-nav-bar title="我的评论" left-arrow fixed class="jump-nav-bar"
                     @click-left="back"/>
        <van-row class="jump-usercent-header" type="flex">
            <van-col span="6">
                <img src="../../assets/avatar.png">
            </van-col>
            <van-col span="6">
                <h5>全部评价</h5>
                <h5>{{data.total}}</h5>
            </van-col>
            <!-- <van-col span="6" >
                 <h5>有图评价</h5>
                 <h5>3</h5>
             </van-col>
             <van-col span="6" >
                 <h5>未评价</h5>
                 <h5>2</h5>
             </van-col>-->
        </van-row>
        <div class="jump-cart-body">
            <!-- <van-row class="jump-comment-no jump-comment-item">
                <van-col span="24">
                   <p>没来的及评价宝贝，还有机会去追评！</p>
               </van-col>
               <van-col span="6">
                 <img src="../../assets/img/test.jpg" />
               </van-col>
               <van-col span="6" >
                 <img src="../../assets/img/test.jpg" />
               </van-col>
               <van-col span="6" >
                 <img src="../../assets/img/test.jpg" />
               </van-col>
               <van-col span="6" >
                 <img src="../../assets/img/test.jpg" />
               </van-col>
             </van-row>-->
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <div class="jump-comment-item" v-for="item in list">
                    <a :href="'#/gooddetail/'+item.evaluate_goods_id">
                        <van-row>
                            <van-col span="18">
                                <p>{{item.createtime}}</p>
                                <!--<h5>{{item.evaluate_info}}</h5>-->
                            </van-col>
                            <!--<van-col span="6">
                                <van-button plain type="info">写追评</van-button>
                            </van-col>-->
                        </van-row>
                        <van-row type="flex">
                            <van-col span="6">
                                <img :src="item.imgUrl"/>
                            </van-col>
                            <van-col span="18" class="item-body">
                                <p>{{item.goods_name}}</p>
                                <p>￥{{item.goods_price}}</p>
                            </van-col>
                        </van-row>
                        <van-row>
                            评论内容：{{item.evaluate_info}}
                        </van-row>
                    </a>
                </div>
                <!--<div class="jump-comment-item">
                    <van-row>
                        <van-col span="18">
                            <p>2019-06-14</p>
                            <h5>发货很快，包装也很好!</h5>
                        </van-col>
                        <van-col span="6">
                            <van-button plain type="info">写追评</van-button>
                        </van-col>
                    </van-row>
                    <van-row type="flex">
                        <van-col span="6">
                            <img src="../../assets/img/test.jpg"/>
                        </van-col>
                        <van-col span="18" class="item-body">
                            <h5 class="item-title">元兴定制、原料谷物</h5>
                            <p class="item-price">￥12.50</p>
                        </van-col>
                    </van-row>
                </div>-->
            </van-list>
        </div>
        <BackTop />
    </div>
</template>
<script>
    import {NavBar, Row, Col, Button, List} from "vant";

    export default {
        name: "usercomment",
        components: {
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [Button.name]: Button,
            [List.name]: List
        },
        data() {
            return {
                checkedAll: false,
                loading: false,
                finished: false,
                currentPage: 1,
                list: [],
                data: {}
            };
        },
        methods: {
            back() {
                history.back();
            }, onLoad() {
                let that = this
                // 异步更新数据
                that.$api.post(
                    that.jumuc.userCenter.selMyCommentListPage,
                    {"currentPage": that.currentPage, "pageSize": 10},
                    successRes => {
                        that.currentPage = that.currentPage + 1
                        that.data = successRes.data
                        let datalist = successRes.data.list
                        for (let i = 0; i < datalist.length; i++) {
                            that.list.push(datalist[i]);
                        }
                        that.page = successRes.data.pageNum + 1
                        that.total = successRes.data.total
                        // 加载状态结束
                        that.loading = false;

                        // 数据全部加载完成
                        if (that.list.length >= that.total) {
                            that.finished = true;
                        }
                    }
                )

            }
        },
        mounted() {

        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;

    body {
        background-color: #f7f7f7;
    }

    .jump-cart {


        .van-hairline--bottom::after {
            border-bottom-width: 0px;
        }
        &-body {
            padding: 20px 10px 0;
            position: relative;
        }
    }

    .jump-usercent-header {
        padding: 10px;
        background-color: @bule-thame;
        text-align: center;
        h5 {
            color: #f7f7f7;
            font-size: 16px;
            padding-top: 5px;
        }
    }

    .jump-comment {
        &-no > div {
            padding: 0 5px;
        }
        &-item {
            background-color: #fff;
            border-radius: 15px;
            padding: 15px;
            font-size: 14px;
            margin-bottom: 10px;
            p {
                padding-bottom: 10px;
            }
            img {
                width: 100%;
            }
            .van-button {
                font-size: 14px;
                height: 32px;
                line-height: 32px;
                border-radius: 1em;
            }
            h5 {
                font-size: 16px;
                margin-bottom: 10px;
                &.item-title {
                    color: #999;
                    padding-top: 10px;
                }
            }
            .item-body {
                align-items: center;
                position: relative;
            }
            .item-price {
                position: absolute;
                bottom: 0px;
            }
        }
    }
</style>

